export const ERROR_MESSAGES = {
  isNotSubtractedAvailablePTO: 'Bereavement pay is not subtracted from your available PTO',
  willSubtractedAvailablePTO: 'PTO will be subtracted from your available time',
};
